export const state = {
  comfortValues: [],
  comfortIsLoaded: true,
  comfortBadgeClass: {
    'lethal': 'comfort-badge lethal-badge',
    'critical': 'comfort-badge critical-badge',
    'intermediary': 'comfort-badge intermediary-badge',
    'comfortable': 'comfort-badge comfortable-badge',
    'no-data': 'comfort-badge disabled-badge',
  },
  comfortCardClass: {
    'lethal': 'lethal-gradient',
    'critical': 'critical-gradient',
    'intermediary': 'intermediary-gradient',
    'comfortable': 'comfort-gradient',
  },
  comfortAliasNumberClass: {
    'lethal': 'alias-number lethal-alias-number',
    'critical': 'alias-number critical-alias-number',
    'intermediary': 'alias-number intermediary-alias-number',
    'comfortable': 'alias-number comfortable-alias-number',
    'no-data': 'alias-number default-alias-number',
  },
  comfortIcon: {
    'lethal': 'fas fa-exclamation',
    'critical': 'fas fa-exclamation',
    'intermediary': 'fas fa-exclamation',
    'comfortable': 'fas fa-check',
    'no-data': 'fas fa-times',
  },
  comfortCardIcon: {
    'lethal': 'fas fa-exclamation-triangle',
    'critical': 'fas fa-exclamation-triangle',
    'intermediary': 'fas fa-exclamation-triangle',
    'comfortable': 'fas fa-check-circle',
  }
};
